import Badge from './Badge'
import { Menu, Transition } from '@headlessui/react'
import { Fragment, memo } from 'react'
import { MdArrowDropDown, MdSystemUpdate } from 'react-icons/md'
import { HiOutlineSwitchHorizontal, HiOutlineLogout } from 'react-icons/hi'
import { FaMicrosoft, FaUserCircle, FaQuestion } from 'react-icons/fa'

const showRole = (role: string) => {
  switch(role) {
    case 'Admins':
    case 'Admin':
      return <Badge variant='text-white bg-blue-700 text-xs font-bold'>{role}</Badge>
    case 'LeaderLine':
    case 'Leaderline':
    case 'LeaderLines':
      return <Badge variant='text-white bg-orange-400 text-xs font-bold'>{role}</Badge>
    case 'TeamLeader':
      return <Badge variant='text-white bg-rose-500 text-xs font-bold'>{role}</Badge>
    case 'Inventory':
      return <Badge variant='text-white bg-green-600 text-xs font-bold'>{role}</Badge>
    case 'Checker':
      return <Badge variant='text-white bg-violet-600 text-xs font-bold'>{role}</Badge>
    default:
      return <Badge variant='text-white bg-gray-600 text-xs font-bold'>{role}</Badge>
  }
}

function UserProfile(
  {
    username,
    role,
    onCheckNewVersion,
    onSwitchRole,
    onSignOut,
    disabledSwitchRole = false,
  }: {
    username: string,
    role: string,
    onSwitchRole?: () => void,
    onCheckNewVersion?: () => void,
    onSignOut?: () => void,
    disabledSwitchRole?: boolean
  }
) {

  const onSignInMicrosoft365 = () => {
    window.open(`https://biomanu.sharepoint.com/sites/DigitalProductionInspection-${process.env.REACT_APP_ENV}`, '_blank');
  }
  
  return <div className="inline-flex items-center justify-start gap-3">
    <FaUserCircle size={28} className='text-white '/>
    <div className="inline-flex flex-col items-start justify-center gap-[0.125rem]">
      <Menu as="div" className="relative inline-block text-left" >
        <div>
          <Menu.Button
            className={`block mt-4 md:flex items-center md:mt-0 text-sm font-bold text-white`}>
            {username}
            <MdArrowDropDown size={20}/>
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
            >
            <Menu.Items className="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
              <p className='px-3 py-3'>สวัสดี, <span className='font-bold '>{username}</span></p>
              <div className="px-1 py-1 ">
                <Menu.Item disabled={disabledSwitchRole}>
                  {({ active, disabled }) => (
                    <button
                      className={`${
                        active ? 'bg-header text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm disabled:opacity-50`}
                      disabled={disabled}
                      onClick={onSwitchRole}
                    >
                      <HiOutlineSwitchHorizontal
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      เปลี่ยน Role
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-header text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      onClick={onCheckNewVersion}
                    >
                      <MdSystemUpdate
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      ตรวจสอบ Version ใหม่
                    </button>
                  )}
                </Menu.Item>
              </div>
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-header text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      onClick={onSignInMicrosoft365}
                    >
                      <FaMicrosoft
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      Sign In Microsoft 365
                    </button>
                  )}
                </Menu.Item>
              </div>
              {/* Add new menu : อ่านคู่มือ */}
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-header text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      onClick={() => window.open('https://portal.it.neo-corporate.com/digital-production', '_blank')}
                    >
                      <FaQuestion
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      อ่านคู่มือ
                    </button>
                  )}
                </Menu.Item>
              </div>
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-red-500 text-white' : 'text-red-500'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      onClick={onSignOut}
                    >
                      <HiOutlineLogout
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      ออกจากระบบ
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </div>
      </Menu>
      {showRole(role)}
    </div>
  </div>
}

export default memo(UserProfile)